import { useAuth } from "../api/authUtils/AuthContext";
import { Navigate, useLocation } from 'react-router-dom';

export default function GuestRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  const fromPath = location.state?.from;
  const isValidRedirect = fromPath && fromPath !== location.pathname;
  const redirectTo = isValidRedirect ? location.state?.from : '/dashboard';
  if (user) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
}
